
import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import ServiceContainer from '@flashpointbv/solar-service-container';
import * as VueGoogleMaps from 'gmap-vue';

@Component({
  name: 'store-locator',
  components: ServiceContainer().getComponents(),
  filters: {
    formatUrl(url: string): string {
      return url.indexOf('https') === -1 ? `https://${url}` : url;
    }
  }
})

export default class extends Vue {
  $refs!: {
    gmap: VueGoogleMaps.Map;
    mapsInput: HTMLInputElement;
  };

  @Prop({default: () => []}) private storeList!: Array<object>;
  @Prop({default: () => []}) private args!: Array<string>;
  @Prop({default: null}) private route!: string;
  @Prop({default: () => []}) private filterOptions!: Array<object>;
  @Prop() private salesPointIcon: string;
  @Prop() private specialistIcon: string;
  @Prop() private distributorIcon: string;

  private mapCenter: object = {lat: 52.132633, lng: 5.291266};
  private zoom: number = 4;
  private mapOptions: object = {
    zoomControl: true,
    mapTypeControl: false,
    scaleControl: false,
    streetViewControl: false,
    rotateControl: false,
    fullscreenControl: false,
    disableDefaultUi: true,
  };

  private markerIcons: object = {
  };

  private activeStoreList: Array<object> = [];
  private selectedStore: null | object = null;

  private get storeTypes(): Array<object> {
    return this.filterOptions.map((option) => {
      return {
        ...option,
        icon: this.markerIcons[option['value']],
        checked: true,
      };
    });
  }

  private setSelectedStore(store: object): void {
    this.selectedStore = store;

    setTimeout(() => {
      this.scrollWindow('down');
    }, 100);
  }

  private updateActiveStoreList(type): void {
    this.$set(type, 'checked', !type.checked);
    this.$forceUpdate();

    this.activeStoreList = this.storeList.filter((store) => {
      return this.storeTypes.some((option) => {
        return option['checked'] && option['value'] === store['filter_store_type'];
      });
    });

  }

  private created(): void {
    this.activeStoreList = this.storeList;

    this.$eventBus.$on('country-selected', (val) => {
      this.setMapCenter(val);
    });

    this.markerIcons = {
      sales_point: {
        url: this.salesPointIcon,
        scaledSize: {width: 60, height: 60}
      },
      specialist: {
        url: this.specialistIcon,
        scaledSize: {width: 60, height: 60}
      },
      distributor: {
        url: this.distributorIcon,
        scaledSize: {width: 60, height: 60}
      }
    };

  }

  private setMapCenter(val): void {
    this.$refs.gmap.$mapPromise.then(() => {
      const geocoder = new google.maps.Geocoder();
      const _this = this;

      geocoder.geocode({'address': val}, function (results, status) {
        if (status == google.maps.GeocoderStatus.OK) {
          _this.$refs.gmap.panTo(results[0].geometry.location);
          _this.$refs.gmap.fitBounds(results[0].geometry.viewport);
        }
      });
    });
  }

  private formatPhone(phoneNumber: string): string {
    return phoneNumber.replace(' ', '').replace('-', '');
  }

  private scrollWindow(direction = 'up'): void {
    if (direction === 'up') {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
      return;
    }

    const elementPosition = (document.querySelector('.store__information') as HTMLElement).offsetTop;

    window.scrollTo({
      top: elementPosition - 150,
      behavior: 'smooth'
    });
  }

}
